export default "__VITE_ASSET__CcStNa$s__"